import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DetectDevice from "../../data/DetectDevice";
import SetPage from "../../data/SetPage";
import UserAccount from "../account/UserAccount";
import PersonalBadges from "../badges/PersonalBadges";
import QuizSection from "../quiz/QuizSection";
import DashboardCourseProgress from "./DashboardCourseProgress";
import IssuedCertificates from "./IssuedCertificates";
import refer from "../../assets/images/refer.png";
import WorkshopsSuggestions from "./WorkshopsSuggestions";
import referbanner from "../../assets/images/referral-banner.svg";
import WhatsappBotActivate from "../whatsapp/WhatsappBotActivate";
import VideosSlider from "../tutorials/VideosSlider";
import HackingInternshipBanner from "./HackingInternshipBanner";
import CommunitySuggestions from "../community/CommunitySuggestions";
import Connections from "../connections/Connections";
import { Helmet } from "react-helmet";
import GettingStartedDashboard from "../intros/GettingStartedDashboard";
import GetWalkthroughs from "../../actions/GetWalkthroughs";
import CourseSuggestions from "../community/CourseSuggestions";
import VideoRecommendations from "./VideoRecommendations";
import DashboardCarousel from "./DashboardCarousel";
import CollegesBusinessCta from "../home/CollegesBusinessCta";
import DashboardPlacements from "./DashboardPlacements";
import DashboardPopularCourses from "./DashboardPopularCourses";
import ReviewVideosSlider from "./ReviewVideosSlider";
import ContactSection from "../../components/ContactSection";
import DashboardCta from "./DashboardCta";
import Gallery from "../gallery/Gallery";
import DashboardBanner from "./DashboardBanner";
import OnlineCourses from "../courses/OnlineCourses";
import CoursesList from "../courses/CoursesList";
import GetCourses from "../../actions/GetCourses";
import TestimonialsPage from "../../components/TestimonialsPage";
import watch from "../../assets/watchtoututoialb-banner.png";
import carousel1 from "../../assets/banner1.svg";
import defaultcover from "../../assets/icons/default-cover.png"; // kept even if unused
import caro2 from "../../assets/carouselimg2.png";
import caro1 from "../../assets/carouselimg1.png";
import caro3 from "../../assets/carouselbanner.png";

import { Carousel } from "react-bootstrap";
const Dashboard = ({ account, page }) => {
  const device = DetectDevice();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [access, setaccess] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    SetPage("Dashboard");
    if (account && account.purchases && account.purchases.length > 1) {
      setaccess(true);
    }
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await GetCourses({
        payload: {
          mode: "live",
          limit: 50,
          device: device === "mobile" ? "mobile" : "desktop",
        },
      });
      setCourses(res || []);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        ‍<title>Dashboard</title>‍
        <meta
          name="description"
          content="Login into your account and learn the best skills from our curated courses"
        />
        <meta name="twitter:card" content="" />
        <meta name="twitter:site" content="" />
        <meta name="twitter:creator" content="" />
        <meta name="twitter:title" content="" />
        <meta name="twitter:description" content="" />
        <meta name="twitter:image" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:site_name" content="Silicon minds" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
      </Helmet>
      {account ? (
        <>
          <div
            className="min-vh-100 dashboard-main-wrapper"
            style={{
              background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            }}
          >
            <div className=" container mt-2 py-4">
              <div className="d-flex justify-content-between  row g-4">
                <>
                  <div className="col-lg-8 col-12 sm-p-0 ">
                    {device === "mobile" ? (
                      <>


                        <div>
                          <div className="carousel-container w-100">
                            {/* <Carousel interval={3000} pause="hover" controls indicators>
                                  <Carousel.Item>
                                    <img src={carousel1} alt="Carousel 1" />
                                  </Carousel.Item>
                                  <Carousel.Item>
                                    <img src={carousel1} alt="Carousel 2" />
                                  </Carousel.Item>
                                  <Carousel.Item>
                                    <img src={carousel1} alt="Carousel 3" />
                                  </Carousel.Item>
                                </Carousel> */}
                            <Carousel
                              interval={2500}
                              controls={true}
                              indicators={true}
                              pause="hover"
                              touch={true}
                              className="custom-carousel mt-3"
                            >
                              <Carousel.Item>
                                <img
                                  src={caro2}
                                  alt="Carousel 2"
                                  className="d-block w-100 custom-carousel-img"
                                />
                              </Carousel.Item>

                              <Carousel.Item>
                                <img
                                  src={caro1}
                                  alt="Carousel 3"
                                  className="d-block w-100 custom-carousel-img"
                                />
                              </Carousel.Item>
                              <Carousel.Item>
                                <img
                                  src={caro3}
                                  alt="Carousel 3"
                                  className="d-block w-100 custom-carousel-img"
                                />
                              </Carousel.Item>


                            </Carousel>



                          </div>
                        </div>
                        <div className=" d-block d-lg-none d-xl-none">
                          <UserAccount account={account} />
                        </div>
                        <div className="bg-white mt-3 rounded">
                          <DashboardCourseProgress />
                        </div>

                        <div className="mt-3">
                          <IssuedCertificates account={account} />
                        </div>

                        <div className="mt-3 ">
                          <div className="bg-white p-3">
                            {/* <h4>Latest Student Reviews</h4> */}
                            {/* <ReviewVideosSlider header={true} /> */}
                            <TestimonialsPage />
                          </div>
                        </div>
                        {/* 
                    <div className=" mb-0 mb-md-5 mt-4 bg-white rounded">
                      <GettingStartedDashboard />
                    </div> */}
                      </>
                    ) : (
                      <>


                        <div>
                          <div className="carousel-container w-100">
                            {/* <Carousel interval={3000} pause="hover" controls indicators>
                                  <Carousel.Item>
                                    <img src={carousel1} alt="Carousel 1" />
                                  </Carousel.Item>
                                  <Carousel.Item>
                                    <img src={carousel1} alt="Carousel 2" />
                                  </Carousel.Item>
                                  <Carousel.Item>
                                    <img src={carousel1} alt="Carousel 3" />
                                  </Carousel.Item>
                                </Carousel> */}
                            <Carousel
                              interval={2500}
                              controls={true}
                              indicators={true}
                              pause="hover"
                              touch={true}
                              className="custom-carousel mt-3 "
                            >
                              <Carousel.Item>
                                <img
                                  src={caro2}
                                  alt="Carousel 2"
                                  className="d-block w-100 custom-carousel-img"
                                />
                              </Carousel.Item>

                              <Carousel.Item>
                                <img
                                  src={caro1}
                                  alt="Carousel 3"
                                  className="d-block w-100 custom-carousel-img"
                                />
                              </Carousel.Item>
                              <Carousel.Item>
                                <img
                                  src={caro3}
                                  alt="Carousel 3"
                                  className="d-block w-100 custom-carousel-img"
                                />
                              </Carousel.Item>


                            </Carousel>



                          </div>
                        </div>
                        <div className=" d-block d-lg-none d-xl-none">
                          <UserAccount account={account} />
                        </div>
                        <div className="bg-white mt-3 rounded">
                          <DashboardCourseProgress />
                        </div>

                        <div className="mt-3">
                          <IssuedCertificates account={account} />
                        </div>

                        <div className="mt-3 ">
                          <div className="bg-white p-3">
                            {/* <h4>Latest Student Reviews</h4> */}
                            {/* <ReviewVideosSlider header={true} /> */}
                            <TestimonialsPage />
                          </div>
                        </div>
                        {/* 
                    <div className=" mb-0 mb-md-5 mt-4 bg-white rounded">
                      <GettingStartedDashboard />
                    </div> */}
                      </>
                    )}
                  </div>
                </>

                {device === "mobile" ? (
                  <div className="col-lg-4 p-0 ">
                    {access ? (
                      <>
                        {" "}
                        <Link
                          to="/referral-program"
                          className="text-decoration-none"
                        >
                          <div
                            className="card card-modern mb-4 fade-in overflow-hidden"
                            style={{
                              borderRadius: "1rem",
                              border: "none",
                              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                            }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.transform =
                              "translateY(-5px)")
                            }
                            onMouseLeave={(e) =>
                            (e.currentTarget.style.transform =
                              "translateY(0)")
                            }
                          >
                            <div className="card-body p-0">
                              <div
                                className="bg-success text-white p-4 position-relative"
                                style={{
                                  borderRadius: "1rem",
                                  background:
                                    "linear-gradient(135deg, #1abc9c 0%, #16a085 100%)",
                                }}
                              >
                                <div className="row align-items-center">
                                  <div className="col-8">
                                    <h4 className="fw-bold mb-2">
                                      Refer Friends
                                    </h4>
                                    <h5
                                      className="mb-3"
                                      style={{
                                        color: "#ffc107",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Win ₹500 Each
                                    </h5>
                                    <button
                                      className="btn btn-light"
                                      style={{
                                        borderRadius: "50px",
                                        padding: "10px 30px",
                                        fontWeight: "600",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      <i className="bi bi-gift me-2"></i>View
                                      Details
                                    </button>
                                  </div>
                                  <div className="col-4 text-end">
                                    <i
                                      className="bi bi-people fs-1"
                                      style={{ opacity: "0.75" }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </>
                    ) : (
                      <>
                        {/* <Link
                            to="/referral-program"
                            className="d-flex mt-3 align-items-center"
                          >
                            <img className="w-100 br-5  " src={refer} />
                          </Link> */}
                        <div className="d-none d-lg-block d-xl-block">

                          <UserAccount account={account} />

                        </div>
                      </>
                    )}

                    {account ? (
                      <div className="mt-lg-3 mt-sm-0 mx-1 col-12">
                        {/* <CommunitySuggestions account={account} /> */}
                        {/* <OnlineCourses/> */}

                        {loading ? (
                          <p className="text-center">Loading courses...</p>
                        ) : (
                          <div className="col-12">
                            {courses.slice(0, 4).map((course, index) => (
                              <Link
                                key={index}
                                to={
                                  "/course/" +
                                  course.course_url +
                                  "/" +
                                  course.mode
                                }
                                className="text-decoration-none d-block mb-3"
                              >
                                <div
                                  className="ly-card-horizontal"
                                  style={{
                                    display: "flex",
                                    background: "#fff",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                    overflow: "hidden",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow =
                                      "0 8px 24px rgba(0,0,0,0.15)";
                                    e.currentTarget.style.transform =
                                      "translateY(-4px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow =
                                      "0 4px 12px rgba(0,0,0,0.08)";
                                    e.currentTarget.style.transform =
                                      "translateY(0)";
                                  }}
                                >
                                  {/* IMAGE - LEFT SIDE */}
                                  <div
                                    style={{
                                      width: "140px",
                                      minWidth: "140px",
                                      height: "130px",
                                      overflow: "hidden",
                                      background: "#f0f0f0",
                                    }}
                                  >
                                    <img
                                      src={course.course_cover_url}
                                      alt={course.course_title}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        transition: "transform 0.3s ease",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.transform =
                                          "scale(1.1)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.transform =
                                          "scale(1)";
                                      }}
                                    />
                                  </div>

                                  {/* BODY - RIGHT SIDE */}
                                  <div
                                    className="p-3"
                                    style={{
                                      flex: 1,
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-between",
                                      minWidth: 0,
                                    }}
                                  >
                                    {/* Title */}
                                    <h5
                                      className="ly-title mb-2"
                                      style={{
                                        color: "#1a3a52",
                                        fontWeight: 700,
                                        fontSize: "0.95rem",
                                        lineHeight: "1.3",
                                        margin: 0,
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {course.course_title}
                                    </h5>

                                    {/* Rating */}
                                    <div
                                      className="d-flex align-items-center mb-2"
                                      style={{
                                        fontSize: "0.85rem",
                                        gap: "4px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#ffc107",
                                          letterSpacing: "1px",
                                        }}
                                      >
                                        {Array.from(
                                          {
                                            length: Math.floor(course.rating),
                                          },
                                          (_) => "★",
                                        ).join("")}
                                        {course.rating % 1 >= 0.5 ? "½" : ""}
                                      </span>
                                      <span
                                        style={{
                                          color: "#222",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {course.rating}
                                      </span>
                                      <span
                                        style={{
                                          color: "#888",
                                          fontSize: "0.8rem",
                                        }}
                                      >
                                        (
                                        {course.ratings_count ||
                                          course.course_ratings ||
                                          0}
                                        )
                                      </span>
                                    </div>

                                    {/* Price */}
                                    {/* <div className="d-flex align-items-center justify-content-between gap-2">
                                      <div className="d-flex align-items-center gap-2">
                                        <span
                                          className="ly-price"
                                          style={{
                                            color: "#d32f2f",
                                            fontWeight: 700,
                                            fontSize: "1.1rem",
                                          }}
                                        >
                                          {course.course_price}
                                        </span>
                                        <del
                                          style={{
                                            color: "#999",
                                            fontSize: "0.85rem",
                                            textDecoration: "line-through",
                                          }}
                                        >
                                          {course.course_cutoff_price}
                                        </del>
                                      </div>
                                      <i
                                        className="bi bi-arrow-right"
                                        style={{
                                          color: "#0056d6",
                                          fontWeight: 700,
                                          transition: "transform 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.transform =
                                            "translateX(4px)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.transform =
                                            "translateX(0)";
                                        }}
                                      ></i>
                                    </div> */}
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : null}

                    {access ? (
                      <>
                        <Link
                          to="/referral-program"
                          className="d-flex mt-3 align-items-center"
                        >
                          <img className="w-100 br-5  " src={refer} />
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}

                    <div className="mt-3   d-flex">
                      <Link
                        to="/ethical-hacking-internship"
                        className="d-flex align-items-center"
                      >
                        <img
                          className="w-100 br-5  "
                          src={watch}
                        />
                      </Link>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="col-lg-4 p-0 ">
                      {access ? (
                        <>
                          {" "}
                          <Link
                            to="/referral-program"
                            className="text-decoration-none"
                          >
                            <div
                              className="card card-modern mb-4 fade-in overflow-hidden"
                              style={{
                                borderRadius: "1rem",
                                border: "none",
                                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                                cursor: "pointer",
                                transition: "transform 0.3s ease",
                              }}
                              onMouseEnter={(e) =>
                              (e.currentTarget.style.transform =
                                "translateY(-5px)")
                              }
                              onMouseLeave={(e) =>
                              (e.currentTarget.style.transform =
                                "translateY(0)")
                              }
                            >
                              <div className="card-body p-0">
                                <div
                                  className="bg-success text-white p-4 position-relative"
                                  style={{
                                    borderRadius: "1rem",
                                    background:
                                      "linear-gradient(135deg, #1abc9c 0%, #16a085 100%)",
                                  }}
                                >
                                  <div className="row align-items-center">
                                    <div className="col-8">
                                      <h4 className="fw-bold mb-2">
                                        Refer Friends
                                      </h4>
                                      <h5
                                        className="mb-3"
                                        style={{
                                          color: "#ffc107",
                                          fontWeight: "700",
                                        }}
                                      >
                                        Win ₹500 Each
                                      </h5>
                                      <button
                                        className="btn btn-light"
                                        style={{
                                          borderRadius: "50px",
                                          padding: "10px 30px",
                                          fontWeight: "600",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        <i className="bi bi-gift me-2"></i>View
                                        Details
                                      </button>
                                    </div>
                                    <div className="col-4 text-end">
                                      <i
                                        className="bi bi-people fs-1"
                                        style={{ opacity: "0.75" }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </>
                      ) : (
                        <>
                          {/* <Link
                            to="/referral-program"
                            className="d-flex mt-3 align-items-center"
                          >
                            <img className="w-100 br-5  " src={refer} />
                          </Link> */}
                          <div className="d-none d-lg-block d-xl-block">

                            <UserAccount account={account} />

                          </div>
                        </>
                      )}

                      {account ? (
                        <div className="mt-lg-3 mt-sm-0 mx-1 col-12">
                          {/* <CommunitySuggestions account={account} /> */}
                          {/* <OnlineCourses/> */}

                          {loading ? (
                            <p className="text-center">Loading courses...</p>
                          ) : (
                            <div className="col-12">
                              {courses.slice(0, 4).map((course, index) => (
                                <Link
                                  key={index}
                                  to={
                                    "/course/" +
                                    course.course_url +
                                    "/" +
                                    course.mode
                                  }
                                  className="text-decoration-none d-block mb-3"
                                >
                                  <div
                                    className="ly-card-horizontal"
                                    style={{
                                      display: "flex",
                                      background: "#fff",
                                      borderRadius: "12px",
                                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                      overflow: "hidden",
                                      transition: "all 0.3s ease",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.boxShadow =
                                        "0 8px 24px rgba(0,0,0,0.15)";
                                      e.currentTarget.style.transform =
                                        "translateY(-4px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 12px rgba(0,0,0,0.08)";
                                      e.currentTarget.style.transform =
                                        "translateY(0)";
                                    }}
                                  >
                                    {/* IMAGE - LEFT SIDE */}
                                    <div
                                      style={{
                                        width: "140px",
                                        minWidth: "140px",
                                        height: "130px",
                                        overflow: "hidden",
                                        background: "#f0f0f0",
                                      }}
                                    >
                                      <img
                                        src={course.course_cover_url}
                                        alt={course.course_title}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                          transition: "transform 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.transform =
                                            "scale(1.1)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.transform =
                                            "scale(1)";
                                        }}
                                      />
                                    </div>

                                    {/* BODY - RIGHT SIDE */}
                                    <div
                                      className="p-3"
                                      style={{
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        minWidth: 0,
                                      }}
                                    >
                                      {/* Title */}
                                      <h5
                                        className="ly-title mb-1"
                                        style={{
                                          color: "#1a3a52",
                                          fontWeight: 700,
                                          fontSize: "0.98rem",
                                          lineHeight: "1.3",
                                          margin: 0,
                                          display: "-webkit-box",
                                          WebkitLineClamp: 2,
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                        }}
                                      >
                                        {course.course_title}
                                      </h5>

                                      {/* Rating */}
                                      <div
                                        className="d-flex align-items-center mb-1"
                                        style={{
                                          fontSize: "15px",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#ffc107",
                                            letterSpacing: "1px",
                                          }}
                                        >
                                          {Array.from(
                                            {
                                              length: Math.floor(course.rating),
                                            },
                                            (_) => "★",
                                          ).join("")}
                                          {course.rating % 1 >= 0.5 ? "½" : ""}
                                        </span>
                                        <span
                                          style={{
                                            color: "#222",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {course.rating}
                                        </span>
                                        <span
                                          style={{
                                            color: "#888",
                                            fontSize: "0.8rem",
                                          }}
                                        >
                                          (
                                          {course.ratings_count ||
                                            course.course_ratings ||
                                            0}
                                          )
                                        </span>
                                      </div>

                                      {/* Price */}
                                      <div className="d-flex align-items-center justify-content-between gap-2">
                                        <div className="d-flex align-items-center gap-2">
                                          {/* <span
                                            className="ly-price"
                                            style={{
                                              color: "#d32f2f",
                                              fontWeight: 700,
                                              fontSize: "1.1rem",
                                            }}
                                          >
                                            {course.course_price}
                                          </span> */}
                                          {/* <del
                                            style={{
                                              color: "#999",
                                              fontSize: "0.85rem",
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            {course.course_cutoff_price}
                                          </del> */}
                                        </div>
                                        <i
                                          className="bi bi-arrow-right"
                                          style={{
                                            color: "#0056d6",
                                            fontWeight: 700,
                                            transition: "transform 0.3s ease",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.transform =
                                              "translateX(4px)";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.transform =
                                              "translateX(0)";
                                          }}
                                        ></i>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : null}

                      {access ? (
                        <>
                          <Link
                            to="/referral-program"
                            className="d-flex mt-3 align-items-center"
                          >
                            <img className="w-100 br-5  " src={refer} />
                          </Link>
                        </>
                      ) : (
                        <></>
                      )}

                      <div className="mt-3   d-flex">
                        <Link
                          to="/ethical-hacking-internship"
                          className="d-flex align-items-center"
                        >
                          <img
                            className="w-100 br-5  "
                            src={watch}
                          />
                        </Link>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>


            <style>
              {`
      .dashboard-main-wrapper {
        padding-top: 10px !important;
      }
      @media (max-width: 767px) {
        .dashboard-main-wrapper {
          /* clear the fixed header (~60px) + a neat gap */
          padding-top: 40px !important;
        }
      }

      .custom-carousel {
        width: 100%;
        border-radius: 18px;
        overflow: hidden;
      }

      /* Desktop */
      .custom-carousel .carousel-item {
        height: 290px;
      }

      .custom-carousel-img {
        width: 100%;
        height: 100%;
        object-fit: cover;   /* hero look */
        border-radius: 18px;
        object-position: center center;
      }

      /* Tablet */
      @media (max-width: 991px) {
        .custom-carousel .carousel-item {
          height: 240px;
        }
      }

      /* ✅ Mobile – hero banner look */
      @media (max-width: 576px) {
        .custom-carousel .carousel-item {
          height: 200px;  /* little taller for hero feel */
        }

        .custom-carousel {
          border-radius: 14px;
        }

        .custom-carousel-img {
          border-radius: 14px;
          object-position: left center; 
          /* 👆 banner text mostly left side kabatti */
        }
      }
    `}
            </style>



          </div>
        </>
      ) : null}
    </>
  );
};

export default Dashboard;